const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

// Fetch verso il backend: base URL, header JSON, cookie di sessione fuori da development.
// Lancia un Error con `status` se la risposta non è ok.
export async function apiFetch(path, { method = 'GET', body } = {}) {
  const options = { method, headers: { 'Content-Type': 'application/json' } };
  if (body !== undefined) {
    options.body = JSON.stringify(body);
  }
  if (process.env.NODE_ENV !== 'development') {
    options.credentials = 'include';
  }

  const response = await fetch(`${BASE_URL}${path}`, options);
  const contentType = response.headers.get('content-type') || '';
  const payload = contentType.includes('application/json') ? await response.json() : await response.text();
  if (!response.ok) {
    const error = new Error((payload && payload.message) || 'Network response was not ok');
    error.status = response.status;
    error.body = payload;
    throw error;
  }
  return payload;
}

export const listEvents = (scope) => apiFetch(`/app/events?scope=${scope}`);
export const createEvent = (payload) => apiFetch('/app/events', { method: 'POST', body: payload });
export const getEventInfo = (eventKey) => apiFetch(`/app/event?eventKey=${encodeURIComponent(eventKey)}`);
export const deleteEvent = (eventKey) => apiFetch(`/app/event?eventKey=${encodeURIComponent(eventKey)}`, { method: 'DELETE' });
export const getMe = () => apiFetch('/app/me');
export const updatePrivateEvent = (payload) => apiFetch('/app/private-event', { method: 'PUT', body: payload });
export const getTicketCounts = (fromTs, toTs) => apiFetch(`/app/events/ticket-counts?from=${fromTs}&to=${toTs}`);
export const listWithdrawalEvents = () => apiFetch('/app/withdrawal/events');
export const getWithdrawalEvent = (eventKey) => apiFetch(`/app/withdrawal/event?eventKey=${encodeURIComponent(eventKey)}`);
export const sendWithdrawalNotification = (payload) => apiFetch('/app/withdrawal/send', { method: 'POST', body: payload });
export const getEventDetail = (eventString) => apiFetch(`/app/get-events?event=${encodeURIComponent(eventString)}`);
export const saveEventNotes = (eventKey, notes) => apiFetch('/app/event', { method: 'POST', body: { eventKey, notes } });
export const payTickets = (payload) => apiFetch('/app/ticket/payment', { method: 'POST', body: payload });
